'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Close = require('@material-ui/icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _Input = require('./../Input');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchBarTag = function (_PureComponent) {
  _inherits(SearchBarTag, _PureComponent);

  function SearchBarTag() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchBarTag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchBarTag.__proto__ || Object.getPrototypeOf(SearchBarTag)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isEdited: false,
      tagValue: '',
      widthEditionMode: 0
    }, _this.componentDidUpdate = function (prevProps) {

      if (!prevProps.isSelected && _this.props.isSelected) {
        window.addEventListener('keydown', _this.onKeyDownSelectedTag);
      }
      if (prevProps.isSelected && !_this.props.isSelected) {
        window.removeEventListener('keydown', _this.onKeyDownSelectedTag);
      }
    }, _this.componentWillUnmount = function () {
      window.removeEventListener('keydown', _this.onKeyDownSelectedTag);
    }, _this.onKeyDownSelectedTag = function (e) {
      var _this$props = _this.props,
          deleteTag = _this$props.deleteTag,
          onArrowKey = _this$props.onArrowKey,
          onKeyDownSelectedTagActive = _this$props.onKeyDownSelectedTagActive;
      var key = e.key;

      if (onKeyDownSelectedTagActive) {
        if (key === 'ArrowLeft') {
          onArrowKey('left');
        }
        if (key === 'ArrowRight') {
          onArrowKey('right');
        }
      } else {
        _this.props.activateOnKeyDownSelectedTag();
      }
      if (key !== 'Delete' && key !== 'Backspace' && key !== 'Tab' && key !== 'Enter') return;
      if (key === 'Delete' || key === 'Backspace') {
        deleteTag();
      } else if (key === 'Enter') {
        _this.activateEditionMode();
      } else {
        e.preventDefault();
        _this.props.myRef.current.querySelector('input').focus();
      }
    }, _this.onBlurSelectedTag = function () {
      _this.props.onChangeSelectedTag(false);
      window.removeEventListener('keydown', _this.onKeyDownSelectedTag);
    }, _this.selectTag = function () {
      var selectable = _this.props.selectable;


      if (!selectable) return;
      _this.props.onChangeSelectedTag(true);
    }, _this.editTag = function (_ref2) {
      var tagValue = _ref2.value;

      var comma = tagValue.indexOf(',');
      if (comma > -1) {
        if (tagValue.trim().length === 1) return;
        _this.updateTag();
      }
      _this.setState({ tagValue: tagValue });
    }, _this.activateEditionMode = function () {
      var _this$props2 = _this.props,
          editable = _this$props2.editable,
          value = _this$props2.value,
          index = _this$props2.index;


      if (!editable) return;
      var el = _this.props.myRef.current.querySelectorAll('.search-bar-tag')[index].offsetWidth;
      window.removeEventListener('keydown', _this.onKeyDownSelectedTag);
      _this.setState({ isEdited: true, tagValue: value, widthEditionMode: el + 20 });
    }, _this.renderPrefixedTag = function () {
      var tag = _this.props.value;

      var colorTag = tag.substr(0, 1);
      var simpleTag = tag.substr(1, tag.length - 1);

      return _react2.default.createElement(
        'button',
        {
          className: 'search-bar-tag-inner',
          onClick: _this.selectTag,
          onDoubleClick: _this.activateEditionMode,
          onBlur: _this.onBlurSelectedTag },
        _react2.default.createElement(
          'span',
          { className: 'search-bar-tag-inner--colored' },
          ' ',
          colorTag,
          ' '
        ),
        simpleTag
      );
    }, _this.renderWrappedTag = function () {
      var tag = _this.props.value;

      var colorTag = tag.substr(0, 1);
      var simpleTag = tag.substr(1, tag.length - 2);

      return _react2.default.createElement(
        'button',
        {
          className: 'search-bar-tag-inner',
          onClick: _this.selectTag,
          onDoubleClick: _this.activateEditionMode,
          onBlur: _this.onBlurSelectedTag },
        _react2.default.createElement(
          'span',
          { className: 'search-bar-tag-inner--colored' },
          ' ',
          colorTag,
          ' '
        ),
        simpleTag,
        _react2.default.createElement(
          'span',
          { className: 'search-bar-tag-inner--colored search-bar-tag-inner--colored-right-quote' },
          ' ',
          colorTag,
          ' '
        )
      );
    }, _this.renderHighlightedWordTag = function (searchHighlightWord) {
      var tag = _this.props.value;

      var colorTag = tag.substr(0, searchHighlightWord.length + 1);
      var simpleTag = tag.substr(searchHighlightWord.length + 1, tag.length);
      return _react2.default.createElement(
        'button',
        {
          className: 'search-bar-tag-inner',
          onClick: _this.selectTag,
          onDoubleClick: _this.activateEditionMode,
          onBlur: _this.onBlurSelectedTag },
        _react2.default.createElement(
          'span',
          { className: 'search-bar-tag-inner--colored' },
          ' ',
          colorTag,
          ' '
        ),
        simpleTag
      );
    }, _this.renderTag = function () {
      var tag = _this.props.value;


      var prefixer = ['+', '-', '@', '#'];
      var prefixIndex = prefixer.indexOf(tag[0]);
      if (prefixIndex > -1) {
        return _this.renderPrefixedTag();
      }

      var wrapper = ['"'];
      var prefixWrapper = wrapper.indexOf(tag[0]);
      if (prefixWrapper > -1 && tag[0] === tag[tag.length - 1]) {
        return _this.renderWrappedTag();
      }

      var highlightWords = _this.props.highlightWords;

      var searchHighlightWord = highlightWords.find(function (word) {
        return tag.indexOf(word + ':') === 0;
      });
      if (searchHighlightWord) {
        return _this.renderHighlightedWordTag(searchHighlightWord);
      }

      return _react2.default.createElement(
        'button',
        { className: 'search-bar-tag-inner', onClick: _this.selectTag, onBlur: _this.onBlurSelectedTag, onDoubleClick: _this.activateEditionMode },
        ' ',
        tag,
        ' '
      );
    }, _this.updateTag = function () {
      var _this$props3 = _this.props,
          updateTag = _this$props3.updateTag,
          onlyHashtagOrAt = _this$props3.onlyHashtagOrAt,
          value = _this$props3.value,
          deleteTag = _this$props3.deleteTag;
      var tagValue = _this.state.tagValue;


      if (onlyHashtagOrAt && tagValue[0] !== '@' && tagValue[0] !== '#') {
        return;
      }
      if (tagValue.trim() === '') deleteTag();else if (tagValue !== value) updateTag(tagValue);
      _this.setState({ isEdited: false });
      _this.props.onChangeSelectedTag(false);
      _this.props.myRef.current.querySelector('input').focus();
    }, _this.onKeyPressEditTag = function (_ref3) {
      var key = _ref3.key,
          event = _ref3.event;


      if (key === 'Escape') _this.setState({ isEdited: false });
      if (key === 'Tab') {
        event.preventDefault();
        _this.updateTag();
      }
    }, _this.onBlurEditTag = function () {
      _this.updateTag();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchBarTag, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          deleteTag = _props.deleteTag,
          autoFocus = _props.autoFocus,
          isSelected = _props.isSelected;
      var _state = this.state,
          isEdited = _state.isEdited,
          tagValue = _state.tagValue,
          widthEditionMode = _state.widthEditionMode;


      return _react2.default.createElement(
        'div',
        null,
        !isEdited && _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('search-bar-tag', {
              'search-bar-tag--clicked': isSelected,
              'search-bar-tag--disabled': disabled
            }) },
          this.renderTag(),
          !disabled && _react2.default.createElement(
            'button',
            { className: 'search-bar-btn-close', onClick: deleteTag },
            ' ',
            _react2.default.createElement(_Close2.default, null),
            ' '
          )
        ),
        isEdited && _react2.default.createElement(
          'div',
          { className: 'search-bar-tag--edition', style: { width: widthEditionMode + 'px' } },
          _react2.default.createElement(_Input2.default, {
            autoFocus: autoFocus,
            placeholder: '',
            value: tagValue,
            onChange: this.editTag,
            onEnterPress: this.updateTag,
            onBlur: this.onBlurEditTag,
            onKeyPress: this.onKeyPressEditTag
          })
        )
      );
    }
  }]);

  return SearchBarTag;
}(_react.PureComponent);

SearchBarTag.propTypes = {
  value: _propTypes2.default.string.isRequired,
  editable: _propTypes2.default.bool,
  selectable: _propTypes2.default.bool,
  highlightWords: _propTypes2.default.array.isRequired,
  disabled: _propTypes2.default.bool,
  deleteTag: _propTypes2.default.func.isRequired,
  autoFocus: _propTypes2.default.bool,
  updateTag: _propTypes2.default.func.isRequired,
  onlyHashtagOrAt: _propTypes2.default.bool,
  index: _propTypes2.default.number.isRequired
};

SearchBarTag.defaultProps = {
  editable: true,
  selectable: false,
  disabled: false,
  autoFocus: true,
  onlyHashtagOrAt: false
};

exports.default = SearchBarTag;